export default __webpack_public_path__ + "static/media/vital-sp.12b8290a.svg";